import Vue from 'vue'
const copy = require('copy-to-clipboard')
const vue = new Vue()

export default function copyText(Vue) {
    Vue.directive('copyText', {
        bind(el, binding, vNode, oldVNode, isDestroy) {
            el.style.cursor = 'pointer'
            el.setAttribute('title', el.getAttribute('title') || '点击复制')
            el.addEventListener('click', function(event) {
                copy(event.currentTarget.innerText)
                vue.$message({
                    type: 'success',
                    message: '已复制到粘贴板',
                    showClose: true
                })
            })
        }
    })
}
